import { rankingCommonConfig } from './common'
import { theme as brandTheme } from '@/config/brands'

export const rankingConfig = {
  ...rankingCommonConfig,
  theme: {
    rankGradient: 'none',
    medalNumberTop: '-2px',
    tabActiveColor: brandTheme.primaryColor,
    tabInactiveColor: brandTheme.textSecondary,
    medalBg: brandTheme.bgCard,
    cardBg: brandTheme.bgCard,
    cardBorder: brandTheme.borderPrimary,
  },
  resources: {
    homeBg: '',
    spikeletL: '',
    spikeletR: '',
    goldMedal: '/images/novaris/ranking/rank-badge-gold.svg',
    silverMedal: '/images/novaris/ranking/rank-badge-silver.svg',
    bronze: '/images/novaris/ranking/rank-badge-bronze.svg',
    medal: '/images/novaris/ranking/rank-badge-default.svg',
  },
}
